import StripeCheckoutElement from "./StripeCheckoutElement";
import { Button, Card, Text, Link } from "../../components";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import type { PaymentViewModel } from "./viewModel";

const stripePromise = (() => {
  const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  return key ? loadStripe(key) : null;
})();

export type PaymentViewProps = PaymentViewModel;

function PaymentView(props: PaymentViewProps) {
  return (
    <div className="mt-[16px]">
      <div className="grid grid-cols-1 gap-[24px] lg:grid-cols-2">
        <div className="space-y-[24px]">
          {props.leftCards.map((card, idx) => (
            <Card key={idx} type="advance" {...card} />
          ))}
        </div>

        <Card className="border border-divider bg-table-header space-y-[24px] self-start h-fit">
          <Text level={1} className="font-[700]">
            {props.t("general.billingDetails")}
          </Text>

          <div className="grid gap-[16px]">
            {props.billingItems.map((item, index) => (
              <Card.AdvanceRow key={index} {...item} />
            ))}
          </div>
          {stripePromise && props.data?.clientSecret ? (
            <Elements
              stripe={stripePromise}
              options={{
                clientSecret: props.data.clientSecret,
              }}
            >
              <StripeCheckoutElement payLabel={props.t("general.pay")} />
            </Elements>
          ) : (
            props.data.stripeCheckOutUrl && (
              <Button className="w-full" color="primary" onClick={props.onPay}>
                {props.t("general.pay")}
              </Button>
            )
          )}
          <Link to={props.returnsAndExchangesUrl} newPage>
            <Text
              level={5}
              children={props.t("general.freeReturnsAndExchanges")}
              className="text-text-secondary-light text-center underline mt-[16px] cursor-pointer"
            />
          </Link>
        </Card>
      </div>
    </div>
  );
}

export default PaymentView;
